"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const ReactDom = require("react-dom");
require("@ali/uc-intl-news-jssdk");
const app_1 = require("./app");
const store_1 = require("./store");
const mobx_react_1 = require("mobx-react");
const inject_1 = require("../../lib/inject");
const fx_1 = require("../../lib/fx");
if (process.env.BROWSER) {
    require('./index.less');
}
function initContainer() {
    const divEl = document.createElement('div');
    divEl.setAttribute('id', 'story-sdk-container');
    document.body.append(divEl);
    fx_1.sendEvent('storySdk:ready', {});
}
window.initStorySdk = function initStorySdk(storyConfig) {
    const storyComponents = document.querySelectorAll('story-component');
    const componentInfos = [];
    storyComponents.forEach((com) => {
        componentInfos.push({
            name: com.getAttribute('name'),
        });
    });
    const el = document.querySelector('#story-sdk-container');
    const storySdkStore = new store_1.default(componentInfos, storyConfig);
    ReactDom.render(React.createElement(mobx_react_1.Provider, { inject: inject_1.default },
        React.createElement(app_1.default, { store: storySdkStore })), el);
};
initContainer();
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJpbmRleC50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSwrQkFBZ0M7QUFDaEMsc0NBQXVDO0FBQ3ZDLG1DQUFpQztBQUNqQywrQkFBNkI7QUFDN0IsbUNBQXlFO0FBQ3pFLDJDQUFzQztBQUN0Qyw2Q0FBK0M7QUFDL0MscUNBQXlDO0FBRXpDLElBQUksT0FBTyxDQUFDLEdBQUcsQ0FBQyxPQUFPLEVBQUU7SUFDckIsT0FBTyxDQUFDLGNBQWMsQ0FBQyxDQUFDO0NBQzNCO0FBRUQsU0FBUyxhQUFhO0lBQ2xCLE1BQU0sS0FBSyxHQUFHLFFBQVEsQ0FBQyxhQUFhLENBQUMsS0FBSyxDQUFDLENBQUM7SUFDNUMsS0FBSyxDQUFDLFlBQVksQ0FBQyxJQUFJLEVBQUUscUJBQXFCLENBQUMsQ0FBQztJQUNoRCxRQUFRLENBQUMsSUFBSSxDQUFDLE1BQU0sQ0FBQyxLQUFLLENBQUMsQ0FBQztJQUM1QixjQUFTLENBQUMsZ0JBQWdCLEVBQUUsRUFBRSxDQUFDLENBQUM7QUFDcEMsQ0FBQztBQUVBLE1BQWMsQ0FBQyxZQUFZLEdBQUcsU0FBUyxZQUFZLENBQUMsV0FBNEI7SUFDN0UsTUFBTSxlQUFlLEdBQUcsUUFBUSxDQUFDLGdCQUFnQixDQUFDLGlCQUFpQixDQUFDLENBQUM7SUFDckUsTUFBTSxjQUFjLEdBQXFCLEVBQUUsQ0FBQztJQUM1QyxlQUFlLENBQUMsT0FBTyxDQUFDLENBQUMsR0FBRyxFQUFFLEVBQUU7UUFDNUIsY0FBYyxDQUFDLElBQUksQ0FBQztZQUNoQixJQUFJLEVBQUUsR0FBRyxDQUFDLFlBQVksQ0FBQyxNQUFNLENBQUM7U0FDakMsQ0FBQyxDQUFDO0lBQ1AsQ0FBQyxDQUFDLENBQUM7SUFDSCxNQUFNLEVBQUUsR0FBRyxRQUFRLENBQUMsYUFBYSxDQUFDLHNCQUFzQixDQUFDLENBQUM7SUFDMUQsTUFBTSxhQUFhLEdBQUcsSUFBSSxlQUFhLENBQUMsY0FBYyxFQUFFLFdBQVcsQ0FBQyxDQUFDO0lBQ3JFLFFBQVEsQ0FBQyxNQUFNLENBQ1gsb0JBQUMscUJBQVEsSUFBQyxNQUFNLEVBQUUsZ0JBQWU7UUFDN0Isb0JBQUMsYUFBUSxJQUFDLEtBQUssRUFBRSxhQUFhLEdBQUksQ0FDM0IsRUFDVCxFQUFFLENBQUMsQ0FBQztBQUNkLENBQUMsQ0FBQztBQUVGLGFBQWEsRUFBRSxDQUFDIn0=